import { NgModule } from '@angular/core';
import { LightningBackgroundComponent } from './lightning-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        LightningBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        LightningBackgroundComponent
    ]
})
export class NcLightningBackgroundModule { }